import React from 'react';
import styled from '@emotion/styled';
import { Dialog, type DialogProps } from '@mui/material';
import { cs } from '@bbkAdminUtils/css-utils';
import { stingColors } from '@bbkShared/sting-colors';

export const DialogTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: rgba(0, 0, 0, 0.8);
  padding: 0.7rem 1rem;
`;

export const DialogContent = styled.div`
  padding: 1rem;
`;

export const DialogContentBold = styled.div`
  padding: 1rem;
  font-weight: bold;
`;

export const DialogError = styled.div`
  padding: 1rem;
  color: rgb(192, 40, 40);
  word-break: break-all;
`;

export const DialogSaveStep = styled.div`
  padding: 1rem;
  color: ${stingColors.primary['600']};
`;

export const DialogActions = styled.div`
  padding: 1rem;

  button {
    margin-right: 0.5rem;
  }
`;

export const WrappedDialog = (props: DialogProps) => (
  <Dialog
    {...props}
    className={cs(props.className, 'tw-[backdrop-filter:none]')}
    PaperProps={{
      className: 'tw-rounded-[20px] tw-bg-[#F6F8FB]',
    }}
  />
);

export const ConfirmationDialog: React.FC<DialogProps> = (props) => (
  <WrappedDialog
    maxWidth="xs"
    aria-labelledby="brightback-confirmation-dialog"
    fullWidth
    className="bbk-confirmation-dialog"
    {...props}
  />
);
